import React from "react";
import {
  ClipboardText,
  Calculator,
  CheckCircle,
  ArrowRight,
} from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";

const steps = [
  {
    icon: <ClipboardText size={22} weight="duotone" />,
    tKey: 1,
    step: "01",
  },
  {
    icon: <Calculator size={22} weight="duotone" />,
    tKey: 2,
    step: "02",
  },
  {
    icon: <CheckCircle size={22} weight="duotone" />,
    tKey: 3,
    step: "03",
  },
];

export const HowSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section id="how" className="relative py-20 md:py-28">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="kicker">
            <span className="dot" />
            {t("howKicker")}
          </div>
          <h2 className="h-section mt-5 text-white">{t("howTitle")}</h2>
          <p className="mt-4 text-slate-400 text-base md:text-lg">
            {t("howSubtitle")}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div key={s.step} className="relative">
              <div className="glass rounded-2xl p-6 h-full">
                <div className="flex items-center justify-between">
                  <div className="feature-tile">{s.icon}</div>
                  <span className="tabular text-slate-500 text-sm">{s.step}</span>
                </div>
                <h3 className="mt-6 text-xl text-white font-semibold tracking-tight">
                  {t(`how${s.tKey}Title`)}
                </h3>
                <p className="mt-2 text-slate-400 text-sm leading-relaxed">
                  {t(`how${s.tKey}Body`)}
                </p>
              </div>
              {i < steps.length - 1 && (
                <ArrowRight
                  size={16}
                  weight="bold"
                  className="hidden md:block flip-x absolute top-1/2 -end-3.5 -translate-y-1/2 text-slate-600"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
